import firebaseConfig from '../config/firebaseConfig'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, onMessage } from 'firebase/messaging'

const app = initializeApp(firebaseConfig)

const requestToken = async () => {
  let token = ''
  const messaging = getMessaging(app)
  await getToken(messaging, {
    vapidKey:
      'BK8myJH9K1RCxAC7Ei4jpUTnL3gOMNt558Pfhk3QBnSebE7PTsJNh_uZO0ZnEt3We8WkTZt_LRGhzJti1CHqMyo',
  })
    .then((currentToken) => {
      token = currentToken
    })
    .catch((err) => {
      console.log('FCM Token error:', err)
    })
  return token
}

export const requestPermission = async () => {
  return Notification.requestPermission()
    .then((permission) => {
      if (permission === 'granted') {
        return requestToken()
      }
    })
    .catch((err) => {
      console.log('Permission request error:', err)
    })
}

export const onMessageListener = async () => {
  const messaging = getMessaging(app)
  return new Promise((resolve) => {
    onMessage(messaging, async (payload) => {
      resolve(payload)
    })
  })
}
